import { addDays, daysIn, fmt, toAd, type BsYmd, type Cal } from "./calendar.ts";

const names = ["Baisakh", "Jestha", "Asar", "Shrawan", "Bhadra", "Asoj", "Kartik", "Mangsir", "Poush", "Magh", "Falgun", "Chaitra"];
export type Pattern = "YMD" | "DMY";

/** Mirror of Domain Calendar MitiInputParser.Mask. */
export function mask(typed: string, pattern: Pattern): string {
  const digits = typed.replace(/\D/g, "").slice(0, 8);
  const cuts = pattern === "YMD" ? [4, 6] : [2, 4];
  const parts: string[] = [];
  let start = 0;
  for (const c of cuts) { if (digits.length <= c) break; parts.push(digits.slice(start, c)); start = c; }
  parts.push(digits.slice(start));
  return parts.filter((p) => p.length > 0).join("-");
}

/** Mirror of MitiInputParser.Parse (same messages). */
export function parseMiti(input: string, today: BsYmd, pattern: Pattern, cal: Cal): { value?: string; error?: string } {
  const s = input.trim();
  if (!s) return { error: "Miti is required" };
  if (s === "t" || s === "T") return { value: fmt(today) };
  const rel = /^([+-])(\d+)$/.exec(s);
  if (rel) {
    const r = addDays(cal, today, (rel[1] === "+" ? 1 : -1) * Number(rel[2]));
    return r ? { value: fmt(r) } : { error: `'${s}' is outside the calendar` };
  }
  let parts = s.split("-").filter(Boolean);
  if (parts.length === 1 && /^\d{8}$/.test(s)) parts = pattern === "YMD" ? [s.slice(0, 4), s.slice(4, 6), s.slice(6)] : [s.slice(0, 2), s.slice(2, 4), s.slice(4)];
  const n = parts.map(Number);
  if (n.some(Number.isNaN)) return { error: `'${s}' is not a miti; type YYYY-MM-DD, t, +n or -n` };
  let y: number, m: number, d: number;
  if (n.length === 1) { y = today.y; m = today.m; d = n[0]!; }
  else if (n.length === 2) { y = today.y; [m, d] = pattern === "YMD" ? [n[0]!, n[1]!] : [n[1]!, n[0]!]; }
  else if (n.length === 3) { [y, m, d] = pattern === "YMD" ? [n[0]!, n[1]!, n[2]!] : [n[2]!, n[1]!, n[0]!]; }
  else return { error: `'${s}' is not a miti; type YYYY-MM-DD, t, +n or -n` };
  const candidate = fmt({ y, m, d });
  const len = daysIn(cal, y, m);
  if (len > 0 && (d < 1 || d > len)) return { error: `${candidate} is not a valid miti; ${names[m - 1]} ${y} has ${len} days` };
  if (!toAd(cal, { y, m, d })) return { error: `${candidate} is outside the calendar` };
  return { value: candidate };
}
